import { render, staticRenderFns } from "./ImportHistoryModal.vue?vue&type=template&id=88e3c7b4"
import script from "./ImportHistoryModal.vue?vue&type=script&lang=ts"
export * from "./ImportHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports